// TODO: CODE STANDARDS RULE 6
export const chartColors = ['#102643', '#76abf3', '#cce5ff', '#8dabc4', '#000']

export const hierarchyItems = {
  DRIVERS: 'driver',
  DEPOTS: 'depot',
  SUPERVISORS: 'supervisor',
  MARKETS: 'market',
  SYSTEM: 'system',
}
